var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.comments,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return col.show
                    ? _c("q-th", { key: col.name, attrs: { props: props } }, [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                        )
                      ])
                    : _vm._e()
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [_vm._v("\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t")]
                  ),
                  _c("q-td", { key: "user", attrs: { props: props } }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(props.row.user) + "\n\t\t\t")
                  ]),
                  (_vm.origin !== "news"
                  ? true
                  : false)
                    ? _c(
                        "q-td",
                        { key: "stars", attrs: { props: props } },
                        [
                          _c("q-rating", {
                            attrs: {
                              color: "amber",
                              icon: "fas fa-star",
                              max: 5,
                              readonly: ""
                            },
                            model: {
                              value: props.row.stars,
                              callback: function($$v) {
                                _vm.$set(props.row, "stars", $$v)
                              },
                              expression: "props.row.stars"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("q-td", { key: "comment", attrs: { props: props } }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          props.row.comment
                            ? _vm.$truncateLink(props.row.comment)
                            : props.row.comment
                        ) +
                        "\n\t\t\t"
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "fas fa-pencil-alt",
                          disable: _vm.manager
                        },
                        on: {
                          click: function($event) {
                            return _vm.editComment(props.row)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          model: {
            value: _vm.show_edit_comment,
            callback: function($$v) {
              _vm.show_edit_comment = $$v
            },
            expression: "show_edit_comment"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_edit_comment = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("comments")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("comment"),
                          disable: ""
                        },
                        model: {
                          value: _vm.comment.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.comment, "comment", $$v)
                          },
                          expression: "comment.comment"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-input", {
                        attrs: { "float-label": _vm.$t("author"), disable: "" },
                        model: {
                          value: _vm.comment.user,
                          callback: function($$v) {
                            _vm.$set(_vm.comment, "user", $$v)
                          },
                          expression: "comment.user"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-select", {
                        attrs: {
                          options: _vm.status_list,
                          "float-label": _vm.$t("status")
                        },
                        model: {
                          value: _vm.comment.status,
                          callback: function($$v) {
                            _vm.$set(_vm.comment, "status", $$v)
                          },
                          expression: "comment.status"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("back"),
                            icon: "fas fa-ban"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_edit_comment = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveComment()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }